const drawerObserver = new MutationObserver((mutations, obs) => {
  const cartDrawer = document.querySelector(".boost-sd__modal");
  if (cartDrawer) {
    console.log("cartDrawer detected");
    const cartTotalSpan = document.querySelector(
      ".boost-sd__cart-price > span"
    );
    cartTotalSpan.dataset.hulkappsCartTotal = "";
    cartTotalSpan.style.paddingRight = "5px";
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartJson) => {
        const itemKeys = cartJson.items.map((item) => item.key);
        const priceSpans = document.querySelectorAll(
          ".boost-sd__cart-item-quantity-price > span:last-child"
        );
        for (let i = 0; i < itemKeys.length; i++) {
          priceSpans[i].dataset.hulkappsCiPrice = "";
          priceSpans[i].dataset.key = itemKeys[i];
        }
        getCartInfo();
      });
  }
});

drawerObserver.observe(document.body, { childList: true, subtree: false });

document.addEventListener(
  "click",
  (event) => {
    if (
      event.target.classList.contains("boost-sd__button") &&
      event.target.textContent.toLowerCase() == "checkout" &&
      is_draft_order
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      hulkappsCheckout($);
    }
  },
  true
);
